import { render, staticRenderFns } from "./ResidencySidebar.vue?vue&type=template&id=2809ba80&"
import script from "./ResidencySidebar.vue?vue&type=script&lang=js&"
export * from "./ResidencySidebar.vue?vue&type=script&lang=js&"
import style0 from "./ResidencySidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports